// Installment Payment Feature - Outside Store (Taste Theme)
(function() {
  
  function formatCurrency(amount) {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  function updateInstallmentInfo() {
    // Target Taste theme price selector
    const priceElements = document.querySelectorAll('span.price-item--regular');
    
    if (priceElements.length === 0) {
      console.log('No price elements found');
      return;
    }

    priceElements.forEach((priceEl) => {
      // Skip jika sudah ada installment info di parent
      if (priceEl.parentElement?.querySelector('.installment-info')) {
        return;
      }

      // Get text content
      const priceText = priceEl.textContent?.trim() || '';
      
      // Match harga
      const priceMatch = priceText.match(/Rp\s*([\d.,]+)/i);
      
      if (!priceMatch) {
        return;
      }

      // Parse harga
      let priceRaw = priceMatch[1].replace(/\./g, '').replace(',', '.');
      const price = parseInt(priceRaw);
      
      if (!price || price < 100000) {
        return;
      }

      const installmentPrice = Math.ceil(price / 3);
      const formattedInstallment = formatCurrency(installmentPrice);

      // Buat container
      const installmentContainer = document.createElement('div');
      installmentContainer.className = 'installment-info';
      
      // Insert setelah price element
      priceEl.parentNode?.insertBefore(installmentContainer, priceEl.nextSibling);

      // Update HTML
      installmentContainer.innerHTML = `
        <span class="installment-info__text">or 3 payments of</span>
        <span class="installment-info__amount">${formattedInstallment}</span>
        <span class="installment-info__text">with</span>
        <img 
          src="https://cdn.shopify.com/s/files/1/0649/7094/8851/files/image-3.png?v=1777740097" 
          alt="ShopeePay Later" 
          class="installment-info__logo"
        >
      `;
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(updateInstallmentInfo, 500);
    });
  } else {
    setTimeout(updateInstallmentInfo, 500);
  }

  // Observer untuk product changes
  const observer = new MutationObserver(function() {
    setTimeout(updateInstallmentInfo, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Variant change listener
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      setTimeout(updateInstallmentInfo, 500);
    }
  });
})();